import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Alert, Box, Snackbar, Typography } from '@mui/material'
import theme from '../theme'
import api from '../services/api'

export default function FormDialog(props) {
    const [handlerSnack, setHandlerSnack] = React.useState(false)
    const [msgSnack, setMsgSnack] = React.useState('')
    const [sevSnack, setSevSnack] = React.useState('success')

    const initialState = {
        cod_empresa: '',
        name: 'Athena',
        athena_url: '',
        webhook_token: '',
    }

    const [state, setState] = React.useState(initialState)
    const isEdit = !!props.editData

    React.useEffect(() => {
        if (props.open) {
            if (props.editData) {
                setState({
                    cod_empresa: props.editData.cod_empresa ?? '',
                    name: props.editData.name || 'Athena',
                    athena_url: props.editData.athena_url || '',
                    webhook_token: props.editData.webhook_token || '',
                })
            } else {
                setState(initialState)
            }
        }
    }, [props.open])

    const handleChange = (event) => {
        setState({
            ...state,
            [event.target.name]: event.target.value,
        })
    }

    const showNotify = (msg, sev = "success") => {
        setMsgSnack(msg)
        setSevSnack(sev)
        setHandlerSnack(true)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        const payload = {
            cod_empresa: parseInt(state.cod_empresa),
            name: state.name,
            athena_url: state.athena_url,
            webhook_token: state.webhook_token,
        }

        const request = isEdit
            ? api.put(`athena-config/${props.editData.id}`, payload)
            : api.post('athena-config/', payload)

        request
            .then(() => {
                showNotify(isEdit ? "Config atualizada com sucesso." : "Config criada com sucesso.")
                props.handlerClose()
                props.updateData()
            })
            .catch(() => {
                showNotify("Um erro ocorreu...", 'error')
            })
    }

    return (
        <div>
            <Snackbar
                open={handlerSnack}
                autoHideDuration={6000}
                onClose={() => setHandlerSnack(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setHandlerSnack(false)} severity={sevSnack} sx={{ width: '100%' }}>
                    {msgSnack}
                </Alert>
            </Snackbar>
            <Dialog open={props.open} fullWidth={true} maxWidth='sm'>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <DialogTitle>{isEdit ? 'Editar Config Athena' : 'Criar Config Athena'}</DialogTitle>
                    <DialogContent>
                        <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
                            Use cod_empresa=0 para config default (ticket avulso)
                        </Typography>
                        <TextField
                            required
                            autoFocus
                            margin="dense"
                            id="cod_empresa"
                            name="cod_empresa"
                            label="Codigo da Empresa"
                            type="number"
                            fullWidth
                            value={state.cod_empresa}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                        />
                        <TextField
                            required
                            margin="dense"
                            id="name"
                            name="name"
                            label="Nome"
                            type="text"
                            fullWidth
                            value={state.name}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                        />
                        <TextField
                            required
                            margin="dense"
                            id="athena_url"
                            name="athena_url"
                            label="URL do Athena"
                            type="text"
                            fullWidth
                            value={state.athena_url}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            placeholder="https://athena.exemplo.com"
                        />
                        <TextField
                            required
                            margin="dense"
                            id="webhook_token"
                            name="webhook_token"
                            label="Webhook Token"
                            type="text"
                            fullWidth
                            value={state.webhook_token}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ color: theme.palette.text.primary }} onClick={props.handlerClose}>
                            Cancelar
                        </Button>
                        <Button sx={{ color: theme.palette.text.primary }} type='submit'>
                            {isEdit ? 'Salvar' : 'Criar'}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </div>
    )
}
